import React from 'react';
import { Facebook, Instagram } from '@mui/icons-material';
import logoMark from '../../assets/images/nky_connect_logo_only.png';
import {
  NKY_CONNECT_FACEBOOK_URL,
  NKY_CONNECT_INSTAGRAM_URL,
} from '../../constants/nkySocialLinks';
import {
  Brand,
  BrandLogo,
  BrandName,
  BrandTagline,
  ContactButton,
  Copyright,
  FooterActions,
  FooterBottom,
  FooterInner,
  FooterLink,
  FooterLinks,
  FooterSocialIconButton,
  FooterTop,
  FooterWrapper,
} from './Footer.styled';

const LEGAL_LINKS = [
  { to: '/terms', label: 'Terms of Service' },
  { to: '/business-terms', label: 'Business Terms' },
  { to: '/privacy', label: 'Privacy Policy' },
  { to: '/sms-terms', label: 'SMS Terms' },
];

const Footer = () => (
  <FooterWrapper>
    <FooterInner>
      <FooterTop>
        <Brand>
          <BrandLogo src={logoMark} alt="" aria-hidden />
          <div>
            <BrandName>NKY Connect</BrandName>
            <BrandTagline>Connecting NKY homeowners with trusted local service pros.</BrandTagline>
          </div>
        </Brand>
        <FooterActions>
          <FooterSocialIconButton
            component="a"
            href={NKY_CONNECT_INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="NKY Connect on Instagram"
          >
            <Instagram />
          </FooterSocialIconButton>
          <FooterSocialIconButton
            component="a"
            href={NKY_CONNECT_FACEBOOK_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="NKY Connect on Facebook"
          >
            <Facebook />
          </FooterSocialIconButton>
          <ContactButton to="/contact">Contact us</ContactButton>
        </FooterActions>
      </FooterTop>
      <FooterBottom>
        <FooterLinks aria-label="Legal">
          {LEGAL_LINKS.map(({ to, label }) => (
            <FooterLink key={to} to={to}>
              {label}
            </FooterLink>
          ))}
        </FooterLinks>
        <Copyright>&copy; {new Date().getFullYear()} NKY Connect. All rights reserved.</Copyright>
      </FooterBottom>
    </FooterInner>
  </FooterWrapper>
);

export default Footer;
